export default "__VITE_PUBLIC_ASSET__c9f1a662__"